import { TabStripTab } from "@progress/kendo-react-layout";
import * as React from "react";
import { useContext, useState } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { PdsrCard } from "./PdsrCard";
import { EditProjectContext } from "../../EditProjectContext";
import getPdsrsForList from "./GetPdsrsForList";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { RouteEditTab } from "../../RouteEditTab";
import { ProjectState } from "../../../ViewModel/ProjectState";
import { CardType } from "../CardType";
import { ReadOnlyProps } from "../../ReadOnlyProps";

export default function ReturnTab({ isReadOnly }: ReadOnlyProps) {
  const { project, routeEditTabSelected } = useContext(EditProjectContext);
  const pdsrsForListView = getPdsrsForList(
    routeEditTabSelected,
    project.PdsrsOnThisProject,
    project.FTLRoutes
  );
  const [deletionAllowed, setDeletionAllowed] = useState<boolean>(true);

  return [
    <TabStripTab key="Return" title={`Return (${project.PdsrsOnThisProject?.length || 0})`}>
      <div>
        <Droppable
          droppableId={CardType.pdsr}
          key="2"
          type={CardType.dragCard}
          isDropDisabled
          ignoreContainerClipping
        >
          {(provided) => {
            return (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {pdsrsForListView?.map((pdsr: PdsrClientViewModel, index) => {
                  const key = `${pdsr?.PlantGsdb} ${pdsr.DockCode} ${pdsr?.SupplierGsdb} ${pdsr.UsedInFtlRoutes}`;
                  return (
                    <Draggable
                      key={pdsr.PdsrId}
                      draggableId={pdsr.PdsrId?.toString() ?? ""}
                      index={index}
                      isDragDisabled={
                        routeEditTabSelected === RouteEditTab.Ltl ||
                        project.State !== ProjectState.Sandbox ||
                        isReadOnly
                      }
                    >
                      {(innerProvided, snapshot) => {
                        return (
                          <div
                            ref={innerProvided.innerRef}
                            style={{
                              zIndex: "2",
                            }}
                            {...innerProvided.draggableProps}
                            {...innerProvided.dragHandleProps}
                          >
                            <PdsrCard
                              key={key}
                              pdsr={pdsr}
                              deletionAllowed={deletionAllowed}
                              setDeletionAllowed={setDeletionAllowed}
                              isReadOnly={isReadOnly}
                            />
                          </div>
                        );
                      }}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>

        {pdsrsForListView?.length === 0 ? <i>No PDSRs added to Project</i> : <div />}
      </div>
    </TabStripTab>,
  ];
}
